import { UserType, UserTypeRedux } from '@models/user/user-type';

export const getUserTypeLabel = (userType: UserTypeRedux | UserType): string => {

  switch (userType) {
    case 'SUPER_ADMIN':
    case 'ADMIN':
      return 'Admin';
    case 'ALUNO':
    case 'ALUNO_B2C':
      return 'Aluno';
    case 'PROFESSOR':
      return 'Corretor';
    case 'COORDENADOR_ESCOLA':
      return 'Coordenador Escola';
    case 'COORDENADOR_TURMA':
      return 'Coordenador Turma';
    case 'COORDENADOR_SAAS':
      return 'Coordenador Saas';
    case 'CORRETOR_SAAS':
      return 'Corretor Saas';
    case 'ASSESSOR':
      return 'Assessor';
    default:
      // Nothing
  }

};
